import {NgModule} from "@angular/core";
import {CoreModule} from "../core/core.module";
import {TrialEditorComponent} from "../trial-curation/components/trial-editor/trial-editor.component";
import {CohortEditorComponent} from "../trial-curation/components/cohort-editor/cohort-editor.component";
import {CohortViewerComponent} from "../trial-curation/components/cohort-viewer/cohort-viewer.component";
import {DrugEditorComponent} from "../trial-curation/components/drug-editor/drug-editor.component";
import {DrugViewerComponent} from "../trial-curation/components/drug-viewer/drug-viewer.component";
import {CriterionViewerComponent} from "./components/criterion-viewer/criterion-viewer.component";
import {CriterionEditorComponent} from "./components/criterion-editor/criterion-editor.component";
import {ConditionEditorComponent} from "../trial-curation/components/condition-editor/condition-editor.component";
import {ConditionViewerComponent} from "../trial-curation/components/condition-viewer/condition-viewer.component";
import {FactorEditorComponent} from "../trial-curation/components/factor-editor/factor-editor.component";
import {FactorViewerComponent} from "../trial-curation/components/factor-viewer/factor-viewer.component";
import {FieldEditorComponent} from "../trial-curation/components/field-editor/field-editor.component";
import {FieldViewerComponent} from "../trial-curation/components/field-viewer/field-viewer.component";
import {TextViewerComponent} from "./components/text-viewer/text-viewer.component";
import {SectionExpanderComponent} from "../trial-curation/components/section-expander/section-expander.component";
import {FormsModule} from "@angular/forms";
import {TrialCurationComponent} from "./components/trial-curation/trial-curation.component";
import {TrialViewerComponent} from "./components/trial-viewer/trial-viewer.component";
import {DynamicFormModule} from "../shared/dynamic-form/dynamic-form.module";
import {DynamicModalLoaderService} from "../layout/services/dynamic-modal-loader.service";
import {SharedModule} from "../shared/shared.module";
import {TrialHeaderComponent} from "./components/trial-header/trial-header.component";
import {TocViewerComponent} from "./components/tocviewer/toc-viewer.component";
import {BiomarkerService} from "./Services/biomarker-service";
import {CohortContainerComponent} from "./components/cohort-container/cohort-container.component";
import {DisorderService} from "./Services/disorder-service";
import {AngularSplitModule} from "angular-split";
import {TrialCohortDrugComponent} from "./components/trial-cohort-drug/trial-cohort-drug.component";
import {QueryBuilderModule} from "@ispm-client/modules/query-builder";
import {LayoutModule} from "@ispm/layout/layout.module";
import {ConditionFactorService} from "./Services/condition-factor-service";
import {SliderService} from "./Services/slider-service";
import {QueryService} from "./Services/query-service";
import {DragulaModule} from "ng2-dragula";
import {LabTestService} from "./Services/labtest-service";
import {RiskService} from "./Services/risk-service";
import {RelapseService} from "./Services/relapse-service";
import {PatientFactorService} from "./Services/patient-factor.service";
import {TherapyService} from "./Services/therapy-service";

@NgModule({
  imports: [
    QueryBuilderModule,
    CoreModule,
    FormsModule,
    DynamicFormModule,
    SharedModule,
    AngularSplitModule.forRoot(),
    LayoutModule,
    DragulaModule
  ],
  declarations: [
    CriterionEditorComponent,
    CriterionViewerComponent,
    CohortContainerComponent,
    CohortEditorComponent,
    CohortViewerComponent,
    ConditionEditorComponent,
    ConditionViewerComponent,
    DrugEditorComponent,
    DrugViewerComponent,
    FactorEditorComponent,
    FactorViewerComponent,
    FieldEditorComponent,
    FieldViewerComponent,
    TextViewerComponent,
    TocViewerComponent,
    TrialViewerComponent,
    TrialEditorComponent,
    TrialCurationComponent,
    TrialHeaderComponent,
    SectionExpanderComponent,
    TrialCohortDrugComponent
  ],
  exports: [
    TextViewerComponent,
    TrialCurationComponent
  ],
  providers: [
    DynamicModalLoaderService,
    BiomarkerService,
    DisorderService,
    ConditionFactorService,
    SliderService,
    QueryService,
    RiskService,
    RelapseService,
    PatientFactorService,
    TherapyService,
    LabTestService
  ]
})
export class TrialCurationModule {

  constructor() {
  }
}
